import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ModalMessageComponent } from 'src/app/components/common/modalmessage/modalmessage.component';
import { Habilidad } from 'src/app/interfaces/habilidad';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { HabilidadService } from 'src/app/services/habilidad/habilidad.service';

@Component({
  selector: 'app-ability-candidate',
  templateUrl: './ability-candidate.component.html',
  styleUrls: ['./ability-candidate.component.scss']
})
export class AbilityCandidateComponent implements OnInit {

  usuario: JwtResponse;
  mostrarEdicion: boolean;
  habilidades: Habilidad[];
  habilidadCandidato: Habilidad;
  noPagina: number;
  formHab: FormGroup;
  editarHabilidad: boolean;
  mostrarHabilidad: boolean;

  constructor(private habilidadService: HabilidadService, private modalService: NgbModal, private formBuilder: FormBuilder) {
    this.usuario = JSON.parse(localStorage.getItem('currentUser'));
    this.habilidadCandidato = {} as Habilidad;
    this.editarHabilidad = false;
    this.mostrarHabilidad = false;
  }

  ngOnInit() {
    this.noPagina = 1;
    this.cargarHabilidadesCandidato();
    this.crearFormularioHabilidad();
  }

  crearFormularioHabilidad(): void {
    this.formHab = this.formBuilder.group({
      nombre: [null, Validators.required],
      descripcion: null,
      nivel: [null, [Validators.pattern(/^([0-9])*$/), Validators.maxLength(3), Validators.required]]
    });
  }

  async cargarHabilidadesCandidato(){
    try {
      const response = await this.habilidadService.obtenerHabilidadesPorIdCandidato(this.usuario.user.idUsuario);
      this.habilidades = response.data;
      if(this.habilidades.length == 0){
        this.mostrarEdicion = true;
      }
    } catch (error) {
      console.error("Error al cargar las habilidades del candidato", error);
    }
  }

  validarHabilidad(): void {
    if(this.habilidadCandidato && this.habilidadCandidato.idHabilidad){
      this.actualizarHabilidad();
    }else{
      if(this.formHab.valid){
        this.registrarHabilidad();
      }
    }
  }

  registrarHabilidad(): void {
    const habilidad: Habilidad = {
      idHabilidad: null,
      nombre: this.formHab.get('nombre').value,
      descripcion: this.formHab.get('descripcion').value,
      nivel: this.formHab.get('nivel').value
    };

    this.habilidadService.registrarHabilidad(this.usuario.user.idUsuario, habilidad).pipe(
      catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.abrirModalMessage("Error", mensajeError);
        return throwError(mensajeError);
      })
    ).subscribe(result => {
      if (result.success) {
        this.ngOnInit();
        this.mostrarEdicion = false;
        this.abrirModalMessage("Éxito", "Se ha registrado correctamente.");
      } else {
        this.abrirModalMessage("Error", "No se ha registrado correctamente " + result.messageError);
        console.error('Error al registrar la habilidad del candidato: ', result.messageError);
      }
    });
  }

  actualizarHabilidad(): void {
    const habilidad: Habilidad = {
      idHabilidad: this.habilidadCandidato.idHabilidad,
      nombre: this.formHab.get('nombre').value || this.habilidadCandidato.nombre,
      descripcion: this.formHab.get('descripcion').value || this.habilidadCandidato.descripcion,
      nivel: this.formHab.get('nivel').value || this.habilidadCandidato.nivel
    };

    this.habilidadService.actualizarHabilidad(habilidad).pipe(
      catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.abrirModalMessage("Error", mensajeError);
        return throwError(mensajeError);
      })
    ).subscribe(result => {
      if (result.success) {
        this.ngOnInit();
        this.mostrarEdicion = false;
        this.habilidadCandidato = {} as Habilidad;
        this.abrirModalMessage("Éxito", "Se ha actualizado correctamente.");
      } else {
        this.abrirModalMessage("Error", "No se ha actualizado correctamente " + result.messageError);
        console.error('Error al actualizar la habilidad del candidato: ', result.messageError);
      }
    });
  }

  eliminarHabilidad(idHabilidad: number): void {
    if(this.usuario && this.usuario.user.idUsuario && idHabilidad){
      this.habilidadService.eliminarHabilidadPorId(this.usuario.user.idUsuario, idHabilidad).pipe(
        catchError(error => {
          let mensajeError = '';
          if (error.status === 0) {
            mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
            mensajeError += `Http error: ${error.message}`;
            console.error('se ha producido un error:', error.error);
          } else {
            mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
            mensajeError += `Http error: ${error.message}`;
            console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
          }
          this.abrirModalMessage("Error", mensajeError);
          return throwError(mensajeError);
        })
      ).subscribe(result => {
        if (result.success) {
          this.ngOnInit();
          this.mostrarEdicion = false;
          this.abrirModalMessage("Éxito", "Se ha eliminado correctamente.");
        } else {
          this.abrirModalMessage("Error", "No se ha eliminado correctamente " + result.messageError);
          console.error('Error al eliminar la habilidad del candidato: ', result.messageError);
        }
      });
    }
  }

  habilitarEdicion(habilidad: Habilidad): void{
    this.habilidadCandidato = {} as Habilidad;
    if(habilidad){
      this.mostrarEdicion = true;
      this.editarHabilidad = true;
      this.habilidadCandidato = habilidad;
    }
  }

  mostrarEdicionExperiencia(): void {
    this.mostrarEdicion = true;
    this.editarHabilidad = false;
    this.habilidadCandidato = {} as Habilidad;
  }

  abrirModalMessage(modalTitle: string, modalMessage: string) {
    const modalRef = this.modalService.open(ModalMessageComponent, { centered: true });
    modalRef.componentInstance.modalTitle = modalTitle;
    modalRef.componentInstance.modalMessage = modalMessage;
  }

  mostrarHabilidadData(): void {
    this.mostrarHabilidad = !this.mostrarHabilidad;
  }

  cerrarHabilidadData(): void {
    this.mostrarHabilidad = false;
  }
}
